import HeaderNone from './../../components/component/header/header_none.jsx';

import OurExpertiseComponent from './../../components/component/our_experties_components/our_experties.jsx';


import FooterNone from './../../components/component/footer/footer_none.jsx'
import LaptopFooter from './../../components/component/footer/laptop_footer.jsx';



function OurExpertise() {
    return (
            <main>
                <HeaderNone />
                <OurExpertiseComponent />

                <FooterNone />
                <LaptopFooter />

            </main>
    );
}

export default OurExpertise;

